import { DateTools } from '@treezor/design-system';

import {
  IBaaSRestrictionsGroup,
  ICountryRestrictionsGroup,
  IMccRestrictionsGroup,
  IMidRestrictionsGroup,
  IRestrictionsGroup,
  TRestrictionsGroupType,
} from '@/store/models/restriction.model';

import { IPaymentCard } from '@/features/cards/store/models/card.model';

export const RestrictionsTools = {
  convertToRestrictionsGroup: (
    restrictionsGroup: IBaaSRestrictionsGroup,
    restrictionGroupType: TRestrictionsGroupType,
  ): IRestrictionsGroup => {
    switch (restrictionGroupType) {
      case 'mcc': {
        const { mcc, ...mccRestrictionsGroup } = restrictionsGroup as IMccRestrictionsGroup;
        return { ...mccRestrictionsGroup, restrictions: [...mcc], type: restrictionGroupType };
      }
      case 'mid': {
        const { merchants, ...midRestrictionsGroup } = restrictionsGroup as IMidRestrictionsGroup;
        return { ...midRestrictionsGroup, restrictions: merchants ? [...merchants] : [], type: restrictionGroupType };
      }
      case 'country': {
        const { countries, ...countryRestrictionsGroup } = restrictionsGroup as ICountryRestrictionsGroup;
        return { ...countryRestrictionsGroup, restrictions: [...countries], type: restrictionGroupType };
      }
    }
  },
  convertToBaaSRestrictionsGroup: (restrictionsGroup: IRestrictionsGroup): IBaaSRestrictionsGroup => {
    const { type, restrictions, startDate, ...restRestrictionsGroup } = restrictionsGroup;

    switch (type) {
      case 'mcc':
        return {
          ...restRestrictionsGroup,
          startDate: DateTools.format(startDate, 'api-date-time'),
          mcc: restrictions.map((mcc) => Number(mcc)),
        } as IMccRestrictionsGroup;
      case 'mid':
        return {
          ...restRestrictionsGroup,
          startDate: DateTools.format(startDate, 'api-date-time'),
          merchants: restrictions.map((merch) => String(merch)),
        } as IMidRestrictionsGroup;
      case 'country':
        return {
          ...restRestrictionsGroup,
          startDate: DateTools.format(startDate, 'api-date-time'),
          countries: restrictions.map((country) => String(country)),
        } as ICountryRestrictionsGroup;
    }
  },
  populateCardRestrictionsGroupId: (
    restrictionGroupId: number,
    restrictionGroupType: TRestrictionsGroupType,
  ): Partial<IPaymentCard> => {
    switch (restrictionGroupType) {
      case 'mcc':
        return { mccRestrictionGroupId: restrictionGroupId };
      case 'mid':
        return { merchantRestrictionGroupId: restrictionGroupId };
      case 'country':
        return { countryRestrictionGroupId: restrictionGroupId };
    }
  },
  getCardRestrictionsGroupId: (
    paymentCard: IPaymentCard,
    restrictionGroupType: TRestrictionsGroupType,
  ): number | undefined => {
    switch (restrictionGroupType) {
      case 'mcc':
        return paymentCard.mccRestrictionGroupId;
      case 'mid':
        return paymentCard.merchantRestrictionGroupId;
      case 'country':
        return paymentCard.countryRestrictionGroupId;
    }
  },
};
